import { findMatch, hasMinimumLength } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import { requestWorkspaceIcons, requestWorkspaceStates } from './constants';

const requestWorkspaceLocation = (request) => {
  const { results, readStatus, readErrors } = request.steps.locations;
  const details = {
    location: null,
    locations: results,
    locationsReadStatus: readStatus,
    locationsReadErrors: readErrors,
  };

  if (readStatus === states.SUCCESS && results.length > 0) {
    const { value } = findMatch(results, request.workspace_location, 'value') || { value: '' };
    details.location = value;
  }

  return details;
};

const requestWorkspaceStatus = (request, defaultStatus = requestWorkspaceStates.CHECKING) => {
  switch (request.workspaceReadStatus) {
    case states.SUCCESS: return request.workspace_status;
    case states.ERROR:
      return hasErrorCode(request.workspaceReadErrors, errorCodes.notFound)
        ? requestWorkspaceStates.MISSING
        : requestWorkspaceStates.ERROR;
    default: return defaultStatus;
  }
};

export const workspaceStatus = (request, defaultStatus = requestWorkspaceStates.CHECKING) => (
  hasMinimumLength(request.workspace_inbox_url)
    ? requestWorkspaceStates.AVAILABLE
    : requestWorkspaceStatus(request, defaultStatus)
);

export const requestWorkspaceIcon = (request, defaultStatus = requestWorkspaceStates.CHECKING) => {
  const status = workspaceStatus(request, defaultStatus);
  return {
    ...requestWorkspaceIcons[status],
    message: `request.workspace.status.${status}`,
    status,
  };
};

export default requestWorkspaceLocation;
